import {clearFieldValue, type IssueFieldValueType} from '@github-ui/issue-fields-shared/issue-field'
import {commitMutation, graphql} from 'react-relay'
import type {Environment, RecordSourceSelectorProxy} from 'relay-runtime'

import type {DeleteIssueFieldValueInput} from './__generated__/deleteIssueFieldValueMutation.graphql'
import {ISSUE_FIELD_VALUES_PAGE_SIZE} from './constants'

export function commitDeleteIssueFieldValueMutation({
  environment,
  input,
  onCompleted,
  onError,
}: {
  environment: Environment
  input: DeleteIssueFieldValueInput
  onCompleted?: () => void
  onError?: (error?: Error) => void
}) {
  return commitMutation(environment, {
    mutation: graphql`
      mutation deleteIssueFieldValueMutation($input: DeleteIssueFieldValueInput!) {
        deleteIssueFieldValue(input: $input) {
          success
          issue {
            id
          }
        }
      }
    `,
    variables: {
      input,
    },
    onCompleted: () => {
      onCompleted?.()
    },
    onError: error => onError?.(error),
    optimisticUpdater: store => {
      const issue = store.get(input.issueId)
      if (issue) {
        handleFieldClear(issue, input.fieldId)
      }
    },
    updater: store => {
      const issue = store.get(input.issueId)
      if (issue) {
        handleFieldClear(issue, input.fieldId)
      }
    },
  })
}

// Helper to handle field clearing logic
const handleFieldClear = (issue: ReturnType<RecordSourceSelectorProxy['get']>, fieldId: string) => {
  if (!issue) {
    return
  }
  const fieldValues = issue.getLinkedRecord('issueFieldValues', {first: ISSUE_FIELD_VALUES_PAGE_SIZE})
  if (!fieldValues) {
    return
  }

  const nodes = fieldValues.getLinkedRecords('nodes') || []
  const clearedNode = nodes.find(node => node?.getLinkedRecord('field')?.getDataID() === fieldId)
  if (!clearedNode) {
    return
  }

  const type = clearedNode.getType() as IssueFieldValueType

  clearFieldValue(clearedNode, type)
}
